/* unplugin-vue-components disabled */import { render } from "./ClothingStore.vue?vue&type=template&id=1e505018&scoped=true"
import script from "./ClothingStore.vue?vue&type=script&lang=js"
export * from "./ClothingStore.vue?vue&type=script&lang=js"

import "./ClothingStore.vue?vue&type=style&index=0&id=1e505018&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e505018"]])

export default __exports__